import { SET_INTERVALO_GERAL, SET_INTERVALO_FILTRO, DEL_INTERVALO_FILTRO } from '../actions/actionTypes';

const initialState = {
    intervaloGeral: 50,
    filtro: [],
};

export const intervaloReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_INTERVALO_GERAL:
            return {
                ...state,
                intervaloGeral: action.payload,
            };
        case SET_INTERVALO_FILTRO:
            state.filtro.push(action.payload);
            return {
                ...state,
            };
        case DEL_INTERVALO_FILTRO:
            state.filtro.splice(
                state.filtro.findIndex((item) => item.value === action.payload),
                1
            );
            return {
                ...state,
            };

        default:
            return state;
    }
};
